$(function(){
  $('.jcarousel img').wrapAll('<ul />').wrap('<li />');
  TBGCarousel.Init();
  TBGUtilityLinks.Init();
});

var TBGCarousel = {
	Init:function(){
		this.CarouselWrapper = $('.jcarousel');
		this.NextLink = $('.jcarousel-control-next');
		this.PreviousLink = $('.jcarousel-control-prev');
		this.CarouselWrapper.jcarousel({
			animation: {
		        duration: 1500,
		        easing:   'easeInOutExpo'
		    }
		});

        this.UpdateImagesSize();
		this.BindCarouselNavigationEvents();
        this.LoadAutoScroll();
		$(window).bind('resize', TBGCarousel.UpdateImagesSize);
	},
	UpdateImagesSize:function(){
		$('ul li', TBGCarousel.CarouselWrapper).width($(window).width() * 0.8);
		$('ul li img', TBGCarousel.CarouselWrapper).width($(window).width() * 0.8);
	},
	BindCarouselNavigationEvents:function(){
		this.PreviousLink
		.bind('jcarouselcontrol:active', TBGCarousel.ActivateNav)
        .bind('jcarouselcontrol:inactive', TBGCarousel.DeactivateNav)
        .jcarouselControl({ target: '-=1'});

        this.NextLink
        .bind('jcarouselcontrol:active', TBGCarousel.ActivateNav)
        .bind('jcarouselcontrol:inactive', TBGCarousel.DeactivateNav)
        .jcarouselControl({ target: '+=1' });

        /*$('.jcarousel-pagination')
        .bind('jcarouselpagination:active', 'a', function() { $(this).addClass('active');})
        .bind('jcarouselpagination:inactive', 'a', function() { $(this).removeClass('active');})
        .jcarouselPagination();*/

	},
	ActivateNav:function(){
		$(this).removeClass(TBGCarousel.InactiveNavClassName);
	},
	DeactivateNav:function(){
		$(this).addClass(TBGCarousel.InactiveNavClassName);
	},
	LoadAutoScroll:function(){
		this.CarouselWrapper.jcarouselAutoscroll({
            interval: 2000,
            target: '+=1',
            autostart: true
        });

        this.CarouselWrapper.bind('jcarousel:scrollend', function(event, carousel) {
		    if(TBGCarousel.NextLink.hasClass('inactive')){
		    	TBGCarousel.CarouselWrapper.jcarouselAutoscroll('reload', {
				    interval: 2000,
				    target: '0',
				    autostart: true
				});

		    }
		    if(TBGCarousel.PreviousLink.hasClass('inactive')){
		    	TBGCarousel.CarouselWrapper.jcarouselAutoscroll('destroy');
		    	TBGCarousel.CarouselWrapper.jcarouselAutoscroll({
		    	    interval: 2000,
		    	    target: '+=1',
		    	    autostart: true
		    	});
		    }
		});

	},
	CarouselWrapper:null,
	NextLink:null,
	PreviousLink:null,
	InactiveNavClassName:'inactive'
};

var TBGUtilityLinks = {
	Init:function(){
		this.CarouselWrapper = $('.jcarousel-wrapper');
		this.UtilityContainer = $('#collection-utility-links');
		this.ScrollSpan = $('span', TBGUtilityLinks.UtilityContainer).eq(0);
		this.SliderSpan = $('span', TBGUtilityLinks.UtilityContainer).eq(1);
		this.ProductContainer = $('.products');
		this.BindWindowScrollEvent();
		this.BindClickEvent();
	},
	BindWindowScrollEvent:function(){
		var slided = 0;
		$(window).scroll(function(){
			var docViewTop = $(window).scrollTop();
        	var elemBottom = TBGUtilityLinks.CarouselWrapper.offset().top + TBGUtilityLinks.CarouselWrapper.height();

        	if(docViewTop > elemBottom){
        		if(!slided){
        			TBGUtilityLinks.UtilityContainer.css('display','none');
        			slided = 1
        		}
        		TBGUtilityLinks.UtilityContainer.addClass(TBGUtilityLinks.FixedUtilityLinksClassName).show("slide", {direction: 'right'});
        	}else{
        		if(slided){
        			TBGUtilityLinks.UtilityContainer.css('display','none');
        			slided = 0;
        		}
        		TBGUtilityLinks.UtilityContainer.removeClass(TBGUtilityLinks.FixedUtilityLinksClassName).show("slide", {direction: 'left'});
            }
		});
	},
	BindClickEvent:function(){
		this.ScrollSpan.bind('click', function(){
			var productContainerTop = TBGUtilityLinks.ProductContainer.offset().top;
			if(productContainerTop != $(window).scrollTop()){
				$('html,body').animate({
				    scrollTop: productContainerTop
			    }, 1000, TBGUtilityLinks.Easing);
		    }
		});

		this.SliderSpan.bind('click', function(){
			var carouselTop = TBGUtilityLinks.CarouselWrapper.offset().top;
			if(carouselTop != $(window).scrollTop()){
				$('html,body').animate({
				    scrollTop: carouselTop
			    }, 1000, TBGUtilityLinks.Easing);
		    }else{
			    if(!TBGCarousel.NextLink.hasClass(TBGCarousel.InactiveNavClassName)){
			    	TBGCarousel.NextLink.trigger('click');
			    }
		    }		    
		});
	},
	UtilityContainer:null,
	ScrollSpan:null,
	SliderSpan:null,
	CarouselWrapper:null,
	ProductContainer:null,
	FixedUtilityLinksClassName:'fixed-utility-links',
	Easing:'easeInOutQuart'
};